"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = themeComposer;

/**
 *
 * @param baseTheme: object - Provides reusable variable names for the overrides, such as colors
 * @param overrides: object - Maps out the application of colors, paddings, etc to standard variables consumed by the cake theming system
 * @returns theme: object - Theme object to be consumed by styled-component's themeProvider
 *
 * For more details, please see: https://docs.google.com/document/d/1mOzGkko4THfSoHYn3ZSMpvDKvs4SN1i2rwruhKK4th0
 */
function themeComposer(baseTheme, overrides) {
  var customTheme;

  if (baseTheme && overrides) {
    customTheme = {};
    var targetKey;
    Object.keys(overrides).forEach(function (item) {
      targetKey = overrides[item] && // check that the entry isn't falsy (null or undefined)
      typeof overrides[item] === 'string' && // only need to parse strings - all others will be passed through
      overrides[item].indexOf('baseThemeData.') >= 0 && // check to see if the string reference the base theme data
      overrides[item].substring(overrides[item].indexOf('.') + 1); // and if so, grab the key for the next steep

      customTheme[item] = targetKey ? baseTheme[targetKey] : // grab the needed value from the base theme
      overrides[item]; // just pass through the value from the theme override
    });
  }

  return customTheme;
}